import BlockInfo from './index';

export default { path: '/home/blockInfo', component: BlockInfo };
